import { FunctionComponent, useEffect, useState } from 'react';
import classNames from 'classnames';
import Loading from '@playground/components/Loading';
import { Spec } from '@playground/SQL/models/tests.model';
import { usePyodide } from '@playground/SQL/hooks/usePyodide';
import Specs from './Specs';
import { useTranslation } from 'next-i18next';

const Layout: FunctionComponent = () => {
  const { t } = useTranslation('common');
  const [specs, setSpecs] = useState<Spec[]>([]);
  const {
    pyodide: { tests },
  } = usePyodide();

  useEffect(() => {
    if (tests?.specs) {
      setSpecs(Object.values(tests.specs));
    }
  }, [tests]);

  return (
    <div
      className={classNames(
        'rounded bg-zinc-800 h-full overflow-x-hidden overflow-y-auto p-4 text-white scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-gray-900',
        {
          'border-2 border-green-500': tests?.status === 'success',
          'border-2 border-red-500': tests?.status === 'fail',
          'border-2 border-amber-500': tests?.status === 'running',
        }
      )}
    >
      {tests?.status === 'running' && (
        <p className="w-full flex items-center space-x-2 mt-2 p-4 text-amber-500">
          <Loading />
          <span>{t('codeRunner.runningTests')}</span>
        </p>
      )}
      <Specs specs={specs} />
      {tests?.status === 'success' && (
        <p className="w-full mt-4 p-4 text-green-500 border text-sm border-green-500 border-dotted">
          {t('codeRunner.tests.success')}
        </p>
      )}
      {tests?.status === 'fail' && (
        <p className="w-full mt-4 p-4 text-red-500 border text-sm border-red-500 border-dotted">
          {t('codeRunner.tests.fail')}
        </p>
      )}
    </div>
  );
};

export default Layout;
